<template>
  <div class="pp-button" :class="[cssType, props.type, { disabled: props.disabled }]">
    <slot />
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  type: {
    type: String,
    default: 'primary' // primary blue green gray yellow
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>
